module.exports = __webpack_public_path__ + "img/vs@2x.a21ebe10.png";